<template>
  <!-- <div v-if="!loaded" v-html="info" :style="infoStyle" />
  <div v-else>
  </div> -->
  <div v-if="!loaded" v-html="info" :style="infoStyle" />
  <nav v-else>
    <ul ref="menu" class="menu">
      <li class="logo"><a href="#">{{ title }}</a></li>
      <li v-for="(item, ndxi) in modelData"
        :key="ndxi" ref="items" class="item" :class="{ 'has-submenu': item.subItems }"
        @click.stop="handleToggleItem(ndxi)">
        <a :href="item.itemHref">{{ item.itemName }}</a>
        <ul v-if="item.subItems" class="submenu">
          <li v-for="(subitem, ndxj) in item.subItems" :key="ndxj" class="subitem">
            <a :href="subitem.itemHref">{{ subitem.itemName }}</a>
          </li>
        </ul>
      </li>
      <li ref="toggle" @click="handleToggleMenu" class="toggle">
        <a href="#">
          <b-icon v-if="formData.mobMenuVisible" icon="x"></b-icon>
          <b-icon v-else icon="list"></b-icon>
        </a>
      </li>

    </ul>
  </nav>
</template>

<script>
const CONFIG_ERROR = 'Error in component configuration!'

export default {
  name: 'nav-bar',
  version: '0.0.1',
  props: {
    title: {
      type: String,
      default: ''
    },
    items: {
      type: String,
      default: '[]'
    }
  }, // props
  components: {}, // components
  data () {
    return {
      loaded: false,
      info: '... loading content!',
      infoStyle: { 'text-align': 'left', color: 'black' },
      formData: {
        mobMenuVisible: false
      },
      modelData: []
      // modelData: [
      //   { itemName: 'Home', itemHref: '#' },
      //   { itemName: 'About', itemHref: '#' },
      //   {
      //     itemName: 'Services',
      //     itemHref: '#',
      //     subItems: [{ itemName: 'Blog', itemHref: '#' }, { itemName: 'Blog', itemHref: '#' }, { itemName: 'Blog', itemHref: '#' }]
      //   }, {
      //     itemName: 'Plans',
      //     itemHref: '#',
      //     subItems: [{ itemName: 'Blog', itemHref: '#' }, { itemName: 'Blog', itemHref: '#' }, { itemName: 'Blog', itemHref: '#' }]
      //   },
      //   { itemName: 'Blog', itemHref: '#' },
      //   { itemName: 'Contact', itemHref: '#' }
      // ]
    }
  }, // data
  /* ----- vuejs hooks ----- */
  created () {
    // console.log('TRACE-REMOVE: NavBar.created: this.items is: ', this.items)
    const trimmedItems = this.items.replace(/  {2}|[\t\n\r]/gm,'')
    // console.log('TRACE-REMOVE: NavBar.created: trimmedItems is: ', trimmedItems)
    try {
      this.modelData = JSON.parse(trimmedItems)
      window.addEventListener('click', this.handleClickOutside)
      this.loaded = true
    } catch (e) {
      this.info = CONFIG_ERROR
      this.infoStyle.color = 'red'
    }
  }, // created
  mounted () {}, // mounted
  destroyed() {
    window.addEventListener('click', this.handleClickOutside)
  }, // destroyed
  computed: {}, // computed
  watch: {}, // watch
  methods: {
    /* ----- handlers ----- */
    handleClickOutside (ev) {
      if (!this.$refs.menu.contains(ev.target)) {
          this.handleToggleItem(-1)
        }
    }, // handleClickOutside
    /* Toggle mobile menu */
    handleToggleMenu () {
      if (this.$refs.menu.classList.contains("active")) {
        this.$refs.menu.classList.remove("active");
        this.formData.mobMenuVisible = false
      } else {
        this.$refs.menu.classList.add("active");
        this.formData.mobMenuVisible = true
      }
    }, // handleToggleMenu
    /* Activate Submenu */
    handleToggleItem (itemIndex) {
      for (var i = 0; i < this.modelData.length; i++) {
        if (i === itemIndex && !this.$refs.items[i].classList.contains("submenu-active")) {
          this.$refs.items[i].classList.add("submenu-active")
        } else {
          this.$refs.items[i].classList.remove("submenu-active")
        }
      }
    } // handleToggleItem
  } // methods
}
</script>

<style scoped>
nav {
  background: #222;
  padding: 0 15px;
}
a {
  color: white;
  text-decoration: none;
}
ul {
  margin: 0px;
  /* margin-block-start: 0px;
  margin-block-end: 0px; */
}
.menu,
.submenu {
  list-style-type: none;
}
.logo {
  font-size: 20px;
  padding: 7.5px 10px 7.5px 0;
}
.item {
  padding: 10px;
}
.item.button {
  padding: 9px 5px;
}
.item:not(.button) a:hover,
.item a:hover::after {
  color: #ccc;
}
/* Mobile */
.menu {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
}
.menu li a {
  display: block;
  padding: 15px 5px;
}
.menu li.subitem a {
  padding: 15px;
}
.toggle {
  order: 1;
  font-size: 20px;
}
.item.button {
  order: 2;
}
.item {
  order: 3;
  width: 100%;
  text-align: center;
  display: none;
}
.active .item {
  display: block;
}
.button.secondary {
  /* divider between buttons and menu links */
  border-bottom: 1px #444 solid;
}
/* Submenu up from mobile screens */
.submenu {
  display: none;
}
.submenu-active .submenu {
  display: block;
  z-index: 2;
}
.has-submenu i {
  font-size: 12px;
}
.has-submenu > a::after {
  font-family: "Font Awesome 5 Free";
  font-size: 12px;
  line-height: 16px;
  font-weight: 900;
  /* content: "\f078"; */
  content: "\203A";
  color: white;
  padding-left: 5px;
}
.submenu-active > a::after {
  content: "\2039";
}
.subitem a {
  padding: 10px 15px;
}
.submenu-active {
  background-color: #111;
  border-radius: 3px;
}
/* Tablet menu */
@media all and (min-width: 700px) {
  .menu {
    justify-content: center;
  }
  .logo {
    flex: 1;
  }
  .item.button {
    width: auto;
    order: 1;
    display: block;
  }
  .toggle {
    flex: 1;
    text-align: right;
    order: 2;
  }
  /* Button up from tablet screen */
  .menu li.button a {
    padding: 10px 15px;
    margin: 5px 0;
  }
  .button a {
    background: #0080ff;
    border: 1px royalblue solid;
  }
  .button.secondary {
    border: 0;
  }
  .button.secondary a {
    background: transparent;
    border: 1px #0080ff solid;
  }
  .button a:hover {
    text-decoration: none;
  }
  .button:not(.secondary) a:hover {
    background: royalblue;
    border-color: darkblue;
  }
}
/* Desktop menu */
@media all and (min-width: 960px) {
  .menu {
    align-items: flex-start;
    flex-wrap: nowrap;
    background: none;
  }
  .logo {
    order: 0;
  }
  .item {
    order: 1;
    position: relative;
    display: block;
    width: auto;
  }
  .button {
    order: 2;
  }
  .submenu-active .submenu {
    display: block;
    position: absolute;
    left: 0;
    top: 68px;
    background: #111;
  }
  .toggle {
    display: none;
  }
  .submenu-active {
    border-radius: 0;
  }
}
</style>
